export default {
  init() {

  },
  finalize() {
    $('.navigation-desktop .navigation-menu .menu-item.menu-item-has-children > a').on('click', function(e) {
      e.preventDefault();
      e.stopPropagation();
      $(this).blur();
    });
  },
}


// WEBPACK FOOTER //
// ./scripts/partials/other/navigation.js